import React from 'react'

export default function Rates({ rates }) {

  const rateType = rates?.map(rate =>
    <p key={rate.rate_type}>{ rate.rate_type }:</p>
  )

  const amount = rates?.map((rate, index) =>
    <p key={index} className="font-weight-bold text-right">£ { rate.rate_amount }</p>
  )

  return (
    <section className="container mt-4 mb-4">
      <p className="d-flex justify-content-start align-items-center mb-3">
        <span className="bg-jungle-green circle-icon sm m-0">
          <i className="icon icon-coin text-light-blue"></i>
        </span>
        <span className="ml-3 font-weight-bold">Price</span>
      </p>
      <div className="row">
        <div className="col-7">
          <div className="text-left">
            { rateType }
          </div>
        </div>
        <div className="col-5 pr-4">
          { amount }
        </div>
      </div>
    </section>
  )
}
